import { motion } from "framer-motion";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#F3F0EA]">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="overline mb-5">/ The Firm</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#1B3B2B] max-w-3xl">
            A practice built on counsel, not just compliance.
          </h2>
          <div className="mt-8 space-y-5 text-[#4A5D53] text-base leading-relaxed max-w-2xl">
            <p>
              Founded in 2017, Anand Aditya &amp; Co. has grown from a single-partner desk into a
              multi-disciplinary chartered accountancy practice serving promoters of family
              businesses, venture-backed founders, professionals and high-net-worth individuals.
            </p>
            <p>
              We work as an extension of your finance function — quiet, accountable and rigorous.
              Each engagement is reviewed by a partner; every filing carries our name.
            </p>
          </div>

          <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-10 max-w-3xl">
            {[
              { k: "8+", v: "Years in practice" },
              { k: "70+", v: "Clients across the globe" },
              { k: "20+", v: "Industries overseen" },
              { k: "<24h", v: "Average response" },
              { k: "ICAI", v: "Registered firm" },
            ].map((s, i) => (
              <div key={i} data-testid={`about-stat-${i}`}>
                <div className="font-serif-display text-3xl text-[#1B3B2B]">{s.k}</div>
                <div className="overline text-[10px] mt-1 text-[#4A5D53]">{s.v}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
